import { render } from "./EventResourceDrawer.vue?vue&type=template&id=394a03e1&scoped=true"
import script from "./EventResourceDrawer.vue?vue&type=script&lang=js"
export * from "./EventResourceDrawer.vue?vue&type=script&lang=js"

import "./EventResourceDrawer.vue?vue&type=style&index=0&id=394a03e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394a03e1"]])

export default __exports__